import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type CreateBookModalContext = {
  onConfirm: (id: number | null) => void | Promise<void>;
};

let context: CreateBookModalContext | null = null;

export function openCreateBookModal(next: CreateBookModalContext): void {
  context = next;
  ModalComponent.attach("createBookModal", appScope.id);
}

export function getCreateBookModalContext(): CreateBookModalContext | null {
  return context;
}

export function clearCreateBookModalContext(): void {
  context = null;
}
